<template>
  <form :class="{'nx-active': active}"
        :data-vv-scope="scope"
        :id="'scope-' + scope"
        class="nx-form"
        @submit="onSubmit">
    <h2 class="nx-form-legend mb-1 mt-2" v-html="heading" v-if="heading"></h2>
    <div class="nx-form-fieldset">
      <nx-milenium-form-field-generator
        v-for="fieldConfig in fieldsConfig"
        :disabled="disabled"
        :key="`channel-field.${fieldConfig.key}`"
        :field-config="fieldConfig"
        :fields-lines="fieldsLines"
        :field-value="value[fieldConfig.name]"
        :master-channel-value="masterChannelValues[value[fieldConfig.name].linkingField]"
        @linkField="linkField"
      ></nx-milenium-form-field-generator>
    </div>
  </form>
</template>

<script>
import FormScopeGenerator from '@/modules/form/FormScopeGenerator';
import NxMileniumFormFieldGenerator from '@/modules/milenium/components/form/MileniumFormFieldGenerator';
import isEqual from 'lodash/isEqual';

export default {
  components: { NxMileniumFormFieldGenerator },
  extends: FormScopeGenerator,
  props: {
    fieldsLines: {
      type: Object,
      required: true,
    },
    masterChannelValues: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    updateField(field, value) {
      if (this.value
        && this.value[field]
        && isEqual(this.value[field], value)) {
        // Nothing to update
        return;
      }
      this.$emit('input', field, { ...this.value[field], value });
    },
    linkField(params) {
      this.$emit('linkField', params);
    },
  },
};
</script>
